import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as authAPI from 'api/Auth/index';
import { openSnackbar } from 'store/reducers/snackbar';
const initialState = {
  data: null,
  isAuth: false,
  show: true,
  reCaptchaVerify: null,
  tokens: {
    access: null,
    refresh: null
  },
  status: 'init', // "loggingIn" | "loggingOut" | "sessionExpired"
  error: null,
  admin: false,
  tenantMeta: null,
  ui: {
    login: { loading: false },
    msg: ''
  }
};
const getAuthState = (state) => state.auth;

const login = createAsyncThunk('auth/login', async (params, { dispatch, rejectWithValue }) => {
  try {
    const res = await authAPI.login(params);
    return res.data;
  } catch (error) {
    console.error('auth/login', error.response.data?.message);
    dispatch(
      openSnackbar({
        open: true,
        message: error.response.data?.message,
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: false
      })
    );
    return rejectWithValue(error);
  }
});

const reCaptchaVarify = createAsyncThunk('auth/reCaptchaVarify', async (params, { dispatch, rejectWithValue }) => {
  try {
    const res = await authAPI.reCaptchaVarify(params);
    return res.data;
  } catch (error) {
    dispatch(
      openSnackbar({
        open: true,
        message: error.response.data?.message,
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: false
      })
    );
    return rejectWithValue(error);
  }
});

const getTenantLogo = createAsyncThunk('auth/getTenantLogo', async (params, { dispatch, rejectWithValue }) => {
  try {
    const res = await authAPI.getTenantLogo(params);
    return res.data?.data;
  } catch (error) {
    dispatch(
      openSnackbar({
        open: true,
        message: error.response.data?.message,
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: false
      })
    );
    return rejectWithValue(error);
  }
});

const resetPassword = createAsyncThunk('auth/resetPassword', async ({ user }) => {
  if (user === null) return;
});

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,

  reducers: {
    persistLogin: (state) => {
      state.status = 'idle';
    },
    userregister: (state) => {
      state.isAuth = false;
      state.tokens = initialState.tokens;
      state.status = 'unregistered';
    },
    logout: () => {
      return {
        ...initialState,
        status: 'loggingOut',
        show: true
      };
    },
    // sessionExpired: (state) => {
    //   // if (isLocalStorageAvailable()) {
    //   //   localStorage.removeItem("token");
    //   //   localStorage.removeItem("expires");
    //   // }
    //   state.isAuth = false;
    //   state.tokens = initialState.tokens;
    //   state.status = 'sessionExpired';
    //   state.error = 'sessionExpired';
    // },
    setRefreshTokenRes: (state, action) => {
      if (action.payload) {
        state.tokens = { ...state.tokens, ...action.payload };
      }
    }
  },

  extraReducers: {
    // login

    [login.pending]: (state) => {
      state.status = 'loggingIn';
      state.ui.login.loading = true;
    },

    [login.fulfilled]: (state, action) => {
      state.data = action.payload?.data?.user_data;
      state.status = 'idle';
      state.ui.login.loading = false;
      state.tokens.access = action.payload?.data?.access;
      state.tokens.refresh = action.payload?.data?.refresh;
      state.isAuth = true;
    },

    [login.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.login.loading = false;
    },

    [reCaptchaVarify.pending]: (state) => {
      state.status = 'loggingIn';
      state.ui.login.loading = true;
    },

    [reCaptchaVarify.fulfilled]: (state, action) => {
      console.log('ghddcf', action);
      state.reCaptchaVerify = action.payload;
      state.show = true;
      state.status = 'idle';
      state.ui.login.loading = false;
    },

    [reCaptchaVarify.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.login.loading = false;
    },

    // resetPassword
    [resetPassword.pending]: (state) => {
      state.status = 'resetingPassword';
      state.ui.login.loading = true;
      state.ui.error = '';
      state.ui.msg = '';
    },

    [resetPassword.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.msg = action.payload.msg;
      state.ui.login.loading = false;
    },

    [resetPassword.rejected]: (state, action) => {
      state.status = 'idle';
      state.ui.error = action.error.message;
      state.ui.login.loading = false;
    },
    [getTenantLogo.pending]: (state) => {
      state.status = 'fetching tenant meta...';
      state.ui.login.loading = true;
    },

    [getTenantLogo.fulfilled]: (state, action) => {
      state.tenantMeta = action.payload;
      state.status = 'idle';
      state.ui.login.loading = false;
    },

    [getTenantLogo.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.login.loading = false;
    }
  }
});

const { setRefreshTokenRes, persistLogin, logout } = authSlice.actions;

export default authSlice.reducer;

export { setRefreshTokenRes, persistLogin, login, logout, resetPassword, reCaptchaVarify, getAuthState, getTenantLogo };
